import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";

function About({ onNext }) {
  return (
    <SoftBox>
      <SoftBox width="80%" textAlign="center" mx="auto" mb={4}>
        <SoftTypography variant="h4" fontWeight="bold">
          UDS S3 Storage
        </SoftTypography>
        <SoftTypography variant="body1" fontWeight="regular" color="text">
          S3-kompatibler Objektspeicher für skalierbare und zuverlässige 
          Datenspeicherung. Ideal für Backups, Website-Hosting und 
          Anwendungsdaten mit optionalem CDN-Support.
        </SoftTypography>
      </SoftBox>

      <SoftBox mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <SoftTypography variant="h6" fontWeight="medium">
              Storage-Features
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
              - S3-kompatible API <br />
              - Unbegrenzt skalierbarer Speicher <br />
              - Verschiedene Redundanz-Level <br />
              - Bucket-Versionierung <br />
              - Lebenszyklusmanagement
            </SoftTypography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <SoftTypography variant="h6" fontWeight="medium">
              Performance & CDN
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
              - Globales Content Delivery Network <br />
              - Auto-Skalierung der Bandbreite <br />
              - Niedrige Latenzzeiten <br />
              - Edge-Caching <br />
              - DDoS-Schutz inklusive
            </SoftTypography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <SoftTypography variant="h6" fontWeight="medium">
              Sicherheit
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
              - AES-256 Verschlüsselung <br />
              - IAM-Berechtigungssystem <br />
              - HTTPS/TLS-Unterstützung <br />
              - Bucket-Policies <br />
              - Audit-Logging
            </SoftTypography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <SoftTypography variant="h6" fontWeight="medium">
              Integration
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
              - SDK-Unterstützung <br />
              - REST API <br />
              - AWS S3 CLI kompatibel <br />
              - Browser-Upload <br />
              - Webhook-Support
            </SoftTypography>
          </Grid>
        </Grid>
      </SoftBox>

      <SoftBox mt={4} textAlign="center">
        <SoftButton color="info" onClick={onNext}>
          Storage jetzt konfigurieren
        </SoftButton>
      </SoftBox>
    </SoftBox>
  );
}

About.propTypes = {
  onNext: PropTypes.func.isRequired,
};

export default About;